import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, errorText } from "@/lib/api";
import { CrmCells } from "./AdminCrm";

export const InterestTable = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/admin/course-interests`, { headers: authHeaders() })
      .then((r) => setRows(Array.isArray(r.data) ? r.data : []))
      .catch((e) => toast.error(errorText(e)));
  }, []);
  const counts = rows.reduce((a, r) => ({ ...a, [r.course_name]: (a[r.course_name] || 0) + 1 }), {});
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {Object.entries(counts).map(([k, v]) => <span key={k} className="rounded-full bg-teal-50 px-3 py-1 text-[13px] font-semibold text-teal-800">{k}: {v}</span>)}
      </div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table data-testid="admin-interest-table" className="w-full min-w-[1000px] text-left text-[14px]">
          <thead className="bg-slate-50 text-[12px] uppercase tracking-wider text-slate-600">
            <tr>{["Date", "Lead", "Course", "Note", "Emails", "Status", "Notes"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id} data-testid="admin-interest-row">
                <td className="px-4 py-3 text-slate-600">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-4 py-3"><p className="font-semibold text-[#0B1B33]">{r.name}</p><p className="text-slate-600">{r.email}{r.phone ? ` · ${r.phone}` : ""}</p></td>
                <td className="px-4 py-3"><span className="rounded-full bg-[#0B1B33] px-2.5 py-1 text-[12px] font-semibold text-white">{r.course_name}</span></td>
                <td className="px-4 py-3 text-slate-700">{r.note || "-"}</td>
                <td className="px-4 py-3 text-[12px] text-slate-600">Admin: {r.admin_email}<br />User: {r.user_email}</td>
                <CrmCells email={r.email} name={r.name} />
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="px-4 py-12 text-center text-slate-600">No course interest yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
